import { gql } from 'apollo-angular';

/**
 * Operación dedicada para el contador de uso de tokens (estilo Claude).
 * Una sola query modular contra el subgraph `langsmith` del gateway federado.
 * Patrón: features/alerts/services/alerts-v2.graphql.ts (gql en archivo dedicado).
 */
export const MY_TOKEN_USAGE_QUERY = gql`
  query MyTokenUsage {
    myTokenUsage {
      plan
      maxTokens
      usedTokens
      percent
      windowStart
      windowEnd
      active
      lastSynced
      exceeded
    }
  }
`;

/**
 * Desglose del ciclo por `app_feature` (la etiqueta que ponen agent.service.ts y
 * soc-chat-drawer.component.ts en cada run). Va en una operación APARTE a
 * propósito: si el campo fallara o desapareciera del subgraph, la validación
 * tumbaría la query entera — así solo se pierden las porciones, no el aro.
 */
export const MY_TOKEN_USAGE_BREAKDOWN_QUERY = gql`
  query MyTokenUsageBreakdown {
    myTokenUsage {
      breakdown {
        name
        tokens
      }
    }
  }
`;
